import React from 'react';

import styles from './emptyPlaceholderStyles.module.scss';

export const EmptyPlaceholder = () => (
  <div className={styles.placeholder}>
    No data available for selected interaction
  </div>
);
